import { render, staticRenderFns } from "./ClaimFormDetail.vue?vue&type=template&id=400ea797&scoped=true"
import script from "./ClaimFormDetail.vue?vue&type=script&lang=ts"
export * from "./ClaimFormDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ea797",
  null
  
)

export default component.exports